import { tabPaths } from '../../../store/index.js';

import { OrderTypes } from '@/constants';

export const queryParamsInitial = {
  page: 1,
  pageSize: 10,
  filters: [],
  sortKey: 'id',
  sortDirection: OrderTypes.Desc,
  tab: tabPaths['monitoringObjects'],
};

export const instructionTypeForFilter = {
  filterId: 'number',
  filterMonitoringObjectName: 'string',
  filterName: 'string',
  filterPartnerClientAccountId: 'number',
};
